//import Pace from 'pace-progress'; // eslint-disable-line



// WEBPACK FOOTER //
// ./scripts/autoload/_pace.js